module.exports = __webpack_public_path__ + "img/elementwidths_jakp.7b3c9168.png";